export default "__VITE_ASSET__CngKSSm2__"